import { getCompanyConfig } from "../../utils/getCompanyConfig";

const Logo = () => {
    const logo = getCompanyConfig("logo");

    return <img className='p-3 col-lg-7 mw-100' src={logo} alt='Logo' />;
};

export default Logo;
